import React, { useState, useEffect } from 'react';
import NavBar            from './components/NavBar';
import HeroSection       from './components/HeroSection';
import ServicesSection   from './components/ServicesSection';
import FeaturesSection   from './components/FeaturesSection';
import BanksSection      from './components/BanksSection';
import ProcessSection    from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection    from './components/ContactSection';
import Footer            from './components/Footer';
import { ScrollTopButton, WhatsAppButton } from './components/FloatingButtons';
import useTheme          from './hooks/useTheme';

/* ── SEO ─────────────────────────────────────────────────────── */
function useSEO() {
  useEffect(() => {
    document.title =
      'Future Fund Finance | Home Loans, Car Loans, Business Loans – Fast Approval India';

    const metas = [
      ['description', 'Future Fund Finance offers fast, minimal-documentation loans across India – Home Loans, Car Loans, Personal Loans, Business Loans & Loan Against Property from Axis, HDFC, ICICI, AU Bank & all NBFCs.'],
      ['keywords',    'loan india, home loan, car loan, personal loan, business loan, loan against property, HDFC loan, ICICI loan, fast loan, village loan india, NBFC loan'],
      ['robots',      'index, follow'],
      ['og:title',    'Future Fund Finance – Loans Made Simple',                      'property'],
      ['og:description', 'Minimum documentation. Online process. Fast disbursement. Covering all of India.', 'property'],
      ['og:type',     'website',                                                       'property'],
      ['twitter:card', 'summary_large_image'],
    ];

    metas.forEach(([key, content, attr = 'name']) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });

    // Canonical
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://futurefundfinance.in';
  }, []);
}

/* ── App ─────────────────────────────────────────────────────── */
function App() {
  const [dark, setDark] = useState(true);
  const t = useTheme(dark);

  useSEO();

  return (
    <div style={{ background: t.bg, minHeight: '100vh', transition: 'background 0.4s' }}>
      <NavBar           dark={dark} setDark={setDark} t={t} />
      <HeroSection      dark={dark} t={t} />
      <ServicesSection  dark={dark} t={t} />
      <FeaturesSection  dark={dark} t={t} />
      <BanksSection     dark={dark} t={t} />
      <ProcessSection           t={t} />
      <TestimonialsSection dark={dark} t={t} />
      <ContactSection   dark={dark} t={t} />
      <Footer                   t={t} />
      <ScrollTopButton />
      <WhatsAppButton  />
    </div>
  );
}

export default App;
